import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {};

const btcDepositsSlice = createSlice({
  name: "btcDeposits",
  initialState,
  reducers: {
    btcDepositsUpdated(state: any, action: any) {
      state.btcDeposits = action.payload;
    },
  },
});

export const { btcDepositsUpdated } = btcDepositsSlice.actions;
export default btcDepositsSlice.reducer;
